// extracted by mini-css-extract-plugin
export var actions = "_uq-4";
export var item = "_uq-1";
export var price = "_uq-3";
export var quantity = "_uq-2";
export var table = "_uq-0";